import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'mt',
    standalone: true
})
export class MtPipe implements PipeTransform {

  transform(val: any): string {
    if (val) {
      return val;
    }
    return '-';
  }

}
